import { toast } from '@webapp/components/Notification'
import { getMessageFromError } from '@webapp/core/utils/errors/getMessageFromError'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useQueryBillMatchedItems } from '../../models'

export interface IUseBillMatchedItemListPresenterParams {
  sessionId: number
}

/**
 * Exposes `matches` + `totalCost` to the Feature Set: the FS forwards
 * `matches` to `attach-invoice-to-matched-items` (no extra fetch). React
 * Query dedupes with the rendered presenter (shared matches cache).
 */
export const useBillMatchedItemListPresenter = ({
  sessionId,
}: IUseBillMatchedItemListPresenterParams) => {
  const intl = useProcurifyIntl()

  const { matches, totalCost, isLoading } = useQueryBillMatchedItems({
    sessionId,
    onError: (err) => {
      toast.error({
        title: intl.formatMessage(messages.errorTitle),
        children:
          getMessageFromError(err) ??
          intl.formatMessage(messages.genericErrorMessage),
      })
    },
  })

  return {
    data: {
      matches,
      totalCost,
    },
    states: {
      isLoading,
    },
  }
}
